// eslint-disable-next-line import/no-extraneous-dependencies
import { v4 as uuidv4 } from 'uuid'
import { HtmlPatcher } from './htmlPatcher'

class StrechTablePatcher implements HtmlPatcher {
  list: string[] = []

  isTableCellOutsideContainerViewport = (container: HTMLDivElement, td: HTMLTableCellElement) => {
    const containerRect = container.getBoundingClientRect()
    const tdRect = td.getBoundingClientRect()

    return (
      tdRect.left > containerRect.right ||
      tdRect.right < containerRect.left ||
      tdRect.top > containerRect.bottom ||
      tdRect.bottom < containerRect.top
    )
  }

  putInvisibleTableCellToList = (td: HTMLTableCellElement) => {
    const uuid = `td-${uuidv4()}`
    td.setAttribute('id', uuid)
    this.list.push(uuid)
  }

  isTableRowOutsideContainerViewport = (container: HTMLDivElement, tr: HTMLTableRowElement) => {
    const parent = tr.parentElement
    if (parent?.tagName.toLowerCase() === 'thead') {
      return false
    }

    const containerRect = container.getBoundingClientRect()
    const trRect = tr.getBoundingClientRect()

    return (
      trRect.left > containerRect.right ||
      trRect.right < containerRect.left ||
      trRect.top > containerRect.bottom ||
      trRect.bottom < containerRect.top
    )
  }

  putInvisibleTableRowToList = (tr: HTMLTableRowElement) => {
    const uuid = `tr-${uuidv4()}`
    tr.setAttribute('id', uuid)
    this.list.push(uuid)
  }

  collectInvisibleTableCell = (container: HTMLDivElement) => {
    Array.from(container.getElementsByTagName('td'))
      .filter((td) => this.isTableCellOutsideContainerViewport(container, td))
      .forEach((td) => this.putInvisibleTableCellToList(td))

    Array.from(container.getElementsByTagName('tr'))
      .filter((tr) => this.isTableRowOutsideContainerViewport(container, tr))
      .forEach((tr) => this.putInvisibleTableRowToList(tr))
  }

  preprocess = () => {
    Array.from(document.querySelectorAll('[data-testid="table-scrollbar"]')).forEach((div) => {
      this.collectInvisibleTableCell(div as HTMLDivElement)
    })
  }

  isTableCellInList = (td: HTMLTableCellElement) => {
    const uuid = td.getAttribute('id')
    return uuid && this.list.includes(uuid)
  }

  hideTableCell = (td: HTMLTableCellElement) => {
    // eslint-disable-next-line no-param-reassign
    td.style.display = 'none'
  }

  isTableRowInList = (tr: HTMLTableRowElement) => {
    const uuid = tr.getAttribute('id')
    return uuid && this.list.includes(uuid)
  }

  hideTableRow = (tr: HTMLTableRowElement) => {
    // eslint-disable-next-line no-param-reassign
    tr.style.display = 'none'
  }

  patch = (cloneBody: Element) => {
    Array.from(cloneBody.getElementsByTagName('td'))
      .filter((td) => this.isTableCellInList(td))
      .forEach((td) => this.hideTableCell(td))

    Array.from(cloneBody.getElementsByTagName('tr'))
      .filter((tr) => this.isTableRowInList(tr))
      .forEach((tr) => this.hideTableRow(tr))
  }
}

export default StrechTablePatcher
